<template>
  <div class="fixed left-0 right-0 bottom-0 top-0 flex items-center justify-center z-50 bg-semi-transparent-black">
    <DefaultCard :class="`${width}`">
      <Heading class="text-center mb-12">
        <slot name="heading">Notification</slot>
      </Heading>
      <p class="leading-loose text-center mb-16">
        <slot name="message">Message</slot>
      </p>
      <div class="flex justify-center">
        <slot name="button"></slot>
      </div>
    </DefaultCard>
  </div>
</template>

<script>
  import DefaultCard from "./common/layout/DefaultCard";
  import Heading from "./common/Heading";

  export default {
    name: "Notification",
	
    components: {Heading, DefaultCard},
	
    computed: {
      width() {
        if (this.medium) return 'max-w-lg'
        return 'max-w-md';
      }
    },
    props: {
      medium: {
        type: Boolean,
        default: false,
      }
    }
  }
</script>

<style scoped>

</style>
